import './App.css';
import WebsocketClient from './components/websocket/WebsocketClient';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './components/pages/Home';
import Overlay from './components/overlay/Overlay';
import { ChatProvider } from './context/ChatContext';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import { useContext } from 'react';
import { AppContext } from './context/AppContext';
import Games from './components/pages/Games';
import Navbar from './components/Navbar';
import About from './components/pages/about/About';
import GameFrame from './components/games/GameFrame';
import { GamesProvider } from './context/GamesContext';

// Componente interno para acessar os contextos
function AppContent() {
  const { isOpenLogin } = useContext(AppContext);

  return (
    <div className="App">
      <Navbar />
      <Overlay isOpen={isOpenLogin} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/games" element={<Games />} />
        
        {/* Rota dinâmica para o Player do Jogo */}
        {/* O useParams dentro do GameFrame capturará ':gameId' automaticamente */}
        <Route path="/play/:gameId" element={<GameFrame />} />
        
        <Route path="/chat" element={
          <ChatProvider>
            <WebsocketClient /> 
          </ChatProvider>
        } />
        <Route path="/about" element={<About />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppProvider>
          <GamesProvider><AppContent /></GamesProvider>
        </AppProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
